
import { defineComponent, ref, watch, computed } from "vue";
import AdminForm from "@/components/AdminForm.vue";
import store from "@/stores";

export default defineComponent({
  name: "AdminMaintenance",
  components: {
    AdminForm,
  },
  setup() {
    const resource = store.useResource();
    const editManageContent = ref(resource.data.manageContent.message);
    const currentManageContent = computed(
      () => resource.data.manageContent.message
    );
    // メンテナンス情報更新
    const update = async () => {
      await resource.saveManageContent({
        message: editManageContent.value,
        id: resource.data.manageContent.id,
      });
    };
    watch(
      () => resource.data.manageContent.message,
      (newValue) => {
        editManageContent.value = newValue;
      }
    );

    return {
      update,
      editManageContent,
      currentManageContent,
    };
  },
});
